import axios from 'axios';
import { getAuth } from '~/services/auth';
import type { EmptyResponse } from '~/types';

export const getDefaultUrl = () => {
  const config = useRuntimeConfig();
  return config.public.API_BASE_URL;
};

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const api = axios.create({
    baseURL: config.public.API_BASE_URL,
    headers: {
      common: {},
      withCredentials: true
    }
  });
  api.interceptors.response.use(
    response => response,
    async error => {
      if (
        error.response?.status === 401 &&
        error.response?.data?.message === 'Your role has been changed by the Admin. Please sign in again.'
      ) {
        try {
          const response = await getAuth<EmptyResponse>('/v1/logout');
          if (response?.data?.status === 'success') {
            window.location.href = '/login';
          }
          console.error('⛔ Unauthorized - Logging out');
        } catch (logoutError) {
          console.error('Logout failed:', logoutError);
        }
      }
      return Promise.reject(error);
    }
  );

  return {
    provide: {
      api: api
    }
  };
});
